<sp-modal
	class="upgrade-modal"
	[isVisible]="modalVisible()"
	[fullscreen]="false"
	[hasCloseButton]="false"
	[hasCloseBackground]="true"
	(closed)="onModalClosed()"
>
	@if (currentStep() === 'select-plan') {
		<div class="modal-step-container">
			<sp-store-select-plan
				[amount]="amount()"
				[currency]="currency()"
				[description]="'Upgrade to unlock premium features'"
				[initialSelectedProduct]="selectedProduct()"
				(proceedToCheckout)="onProceedToCheckout($event)"
				(checkoutError)="onCheckoutError($event)"
				(checkoutCompleted)="onModalClosed()"
			></sp-store-select-plan>
		</div>
	}
	@if (currentStep() === 'checkout') {
		<div class="modal-step-container">
			<sp-store-checkout
				[amount]="amount()"
				[currency]="currency()"
				[description]="'Upgrade to unlock premium features'"
				[initialPaymentType]="paymentType()"
				(checkoutError)="onCheckoutError($event)"
				(goBack)="onCheckoutBack()"
				(checkoutSucceeded)="onCheckoutSucceeded($event)"
			></sp-store-checkout>
		</div>
	}
	@if (currentStep() === 'receipt') {
		<div class="modal-step-container">
			<sp-store-receipt
				[amount]="amount()"
				[currency]="currency()"
				[description]="'Upgrade to unlock premium features'"
				[initialPaymentType]="paymentType()"
				[initialReceiptData]="receiptData()"
				(checkoutCompleted)="onPaymentSuccess()"
				(checkoutError)="onCheckoutError($event)"
			></sp-store-receipt>
		</div>
	}
</sp-modal>
